import React, { Fragment } from 'react';
import Link from 'redux-first-router-link';
import PropTypes from 'prop-types';
import Social from '../global/Social';
import { SOCIALS_MAP, SLUGS_MAP } from '../../consts';
import { isValid, isText, decodeSpecialCharacters } from '../../utils'

const ArticleHeader = ({
  category,
  subcategory,
  categoryText,
  tags,
  display,
  article,
  isRoster,
  isGuide,
  isSponsored,
  isMobile,
  isContentHub,
  authorTwitter,
  authorInstagram,
  sponsorship,
  hasContentHeader
}) => {
  const showSlugs = (display.taggedSlugs === '1');

  let sponText = '';
  let sponImage = null;
  let sponUrl = null;
  if (isSponsored) {
    sponText = isValid(sponsorship) && isText(sponsorship.sponsorshipBannerOverride) ? sponsorship.sponsorshipBannerOverride : 'Sponsored';
    sponImage = isValid(sponsorship) && isText(sponsorship.sponsorshipImage) ? sponsorship.sponsorshipImage : null;
    sponUrl = isValid(sponsorship) && isText(sponsorship.sponsorshipUrl) ? sponsorship.sponsorshipUrl : null;       
  }
  const renderedSponsorLogo = <img className="sponsor-img" src={sponImage} />;

  // TODO: TAGGED SLUGS
  let slug = null;
  if (isValid(tags)) {
    const slugTags = tags.filter(tag => (SLUGS_MAP[tag]));
    if (slugTags.length > 0 && showSlugs) {
      const slugTag = slugTags[0];
      slug = SLUGS_MAP[slugTag];
    }
  }
  const renderedTaggedSlug = (
    <Fragment>
    { slug &&
      <>
        <div className={slug.className}><a href={slug.url} target="_blank">{slug.text}</a></div>
        <div className="cat-divider"></div>
      </>
    }
    </Fragment>
  );

  const dek = isValid(article.dek) ? decodeSpecialCharacters(article.dek) : null;

  const categoryClassName = (isGuide && isMobile) ? 'category guide' : 'category';
  let headlineClassName = 'hed';
  
  if (isGuide) {
    headlineClassName = 'hed guide';
  }
  if (isContentHub) {
    headlineClassName = 'hed content-hub';
  }

  const altHeader = ['self-care', 'beauty', 'wellness', 'food', 'family', 'fashion', 'wowshop', 'entertainment'].includes(category);

  return (
    <Fragment>
      <div className={categoryClassName}>
        {/* render tagged slug here */}
        {slug && renderedTaggedSlug}
        {/* render category here */}
        <Link
          className={`cat-link ${category} ${altHeader ? '' : 'alt-header'}`}
          to={ { type: 'LANDER', payload: { category } } }>
            {categoryText}
        </Link>
        {isSponsored
          && <span className="spons">
            { !isMobile && <span className="sponsor-line"> | </span> }
            <div className="sponsor-text">{sponText}</div>
            { sponImage && 
              <Fragment>
                {sponUrl ? (
                  <a className="sponsor-img-wrapper" href={sponUrl} target="_blank" rel="noopener noreferrer">
                    {renderedSponsorLogo}
                  </a>
                ) : (
                  <div className="sponsor-img-wrapper">
                    {renderedSponsorLogo}
                  </div>
                )}
              </Fragment>
            }
          </span>
        }
      </div>
      {isValid(article.byline_display.hideHeadline) && article.byline_display.hideHeadline === '1' && !hasContentHeader
        && <h1 className={headlineClassName} dangerouslySetInnerHTML={{ __html: article.headline }}></h1>
      }
      {isText(dek)
        && <h2 className="dek">{dek}</h2>
      }
      {isRoster
        && <div className="author-container author-container-roster">
          <div className="author-text">
            <Social
              className={`icon ${SOCIALS_MAP.instagram.className}`}
              href={authorInstagram}
              parent="Intro" />
            <Social
              className={`icon ${SOCIALS_MAP.twitter.className}`}
              href={authorTwitter}
              parent="Intro" />
          </div>
        </div>
      }
    </Fragment>
  );
};

ArticleHeader.propTypes = {
  category: PropTypes.string,
  categoryText: PropTypes.string,
  tags: PropTypes.array,
  article: PropTypes.object,
  isRoster: PropTypes.bool,
  authorTwitter: PropTypes.string,
  authorInstagram: PropTypes.string,
};

export default ArticleHeader;
